import React from "../_snowpack/pkg/react.js";
import {useTranslation} from "../_snowpack/pkg/react-i18next.js";
import {Col, Divider, Row} from "../_snowpack/pkg/antd.js";
import {formatRupiah} from "../services/Formatters.js";
import {InfoCircleOutlined} from "../_snowpack/pkg/@ant-design/icons.js";
import {Documentation} from "../services/DocumentationService.js";
export const FinancialResultBreakdown = (props) => {
  const {t} = useTranslation();
  const {results, onOpenDocumentation} = props;
  if (!results) {
    return /* @__PURE__ */ React.createElement("div", null, "Invalid Data");
  }
  const monthsInYear = 12;
  const breakEven = {
    years: Math.floor(results.breakEvenPointInMonths / monthsInYear),
    months: Math.round(results.breakEvenPointInMonths % monthsInYear)
  };
  return /* @__PURE__ */ React.createElement("div", {
    className: "ant-table"
  }, /* @__PURE__ */ React.createElement(Divider, {
    style: {marginTop: "1px"},
    orientation: "left"
  }, t("resultTable.financialHeading")), /* @__PURE__ */ React.createElement(Row, {
    gutter: 12
  }, /* @__PURE__ */ React.createElement(Col, {
    span: 15
  }, t("resultTable.currentMonthlyCosts")), /* @__PURE__ */ React.createElement(Col, {
    span: 9
  }, formatRupiah(results.currentMonthlyCosts))), /* @__PURE__ */ React.createElement(Row, {
    gutter: 12
  }, /* @__PURE__ */ React.createElement(Col, {
    span: 15
  }, t("resultTable.remainingMonthlyCosts"), " ", /* @__PURE__ */ React.createElement(InfoCircleOutlined, {
    onClick: () => onOpenDocumentation(Documentation.MinimalPayment, t("resultTable.remainingMonthlyCosts"))
  })), /* @__PURE__ */ React.createElement(Col, {
    span: 9
  }, "- ", formatRupiah(results.remainingMonthlyCosts))), /* @__PURE__ */ React.createElement(Row, {
    gutter: 12
  }, /* @__PURE__ */ React.createElement(Col, {
    span: 15
  }, t("resultTable.monthlyProfit")), /* @__PURE__ */ React.createElement(Col, {
    span: 9,
    className: "total"
  }, formatRupiah(results.monthlyProfit))), /* @__PURE__ */ React.createElement(Row, {
    gutter: 12
  }, /* @__PURE__ */ React.createElement(Col, {
    span: 24
  }, " ")), /* @__PURE__ */ React.createElement(Row, {
    gutter: 12
  }, /* @__PURE__ */ React.createElement(Col, {
    span: 15
  }, t("resultTable.yearlyProfit")), /* @__PURE__ */ React.createElement(Col, {
    span: 9
  }, formatRupiah(results.yearlyProfit))), /* @__PURE__ */ React.createElement(Row, {
    gutter: 12
  }, /* @__PURE__ */ React.createElement(Col, {
    span: 11,
    className: "emphasis"
  }, t("resultTable.breakEven"), " ", /* @__PURE__ */ React.createElement(InfoCircleOutlined, {
    onClick: () => onOpenDocumentation(Documentation.RoiExplanation, t("resultTable.breakEven"))
  })), /* @__PURE__ */ React.createElement(Col, {
    span: 13,
    className: "emphasis"
  }, t("resultTable.breakEvenExplanation", {breakEven}))), /* @__PURE__ */ React.createElement(Row, {
    gutter: 12
  }, /* @__PURE__ */ React.createElement(Col, {
    span: 24
  })));
};
